/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cognito_identity_pool_id": "eu-west-2:0e5f2e97-9223-40f8-a559-643902074c25",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_2OlihHxVl",
    "aws_user_pools_web_client_id": "36s8ctgugnc8n756lou8q03sqr",
    "oauth": {},
    "aws_user_files_s3_bucket": "nuvven-b2b-app0921014c5695490da952f0b646a8cba8app-master",
    "aws_user_files_s3_bucket_region": "eu-west-2"
};


export default awsmobile;
